import RESOURCES from '../enums/resourceEnum';

class TableStateManager {
  static resources = Object.values(RESOURCES);

  /**
   *
   * @param {string} resource to build key name
   * @returns {string} complete key name to search for in localStorage
   */
  static createKey(resource) {
    return `${resource}-table-state`;
  }

  /**
   *
   * @param {string} resource to build key name
   * @param {object} value to store in localStorage
   */
  static setTableState(resource, value) {
    if (!resource) {
      return;
    }

    const key = TableStateManager.createKey(resource);
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   *
   * @param {string} resource where to search
   * @param {object} property to get from local storage
   * @returns {object | string} of tableState containing options for table and searchQuery
   * when @param property is null or either options object or searchQuery string when
   */
  static getTableState(resource, property = null) {
    if (!resource) {
      return;
    }

    const key = TableStateManager.createKey(resource);
    const valueJSON = window.localStorage.getItem(key);

    if (valueJSON) {
      const value = JSON.parse(valueJSON);

      if (property === null) {
        return value;
      }
      if (Object.prototype.hasOwnProperty.call(value, property)) {
        return value[property];
      }
    }
    return { searchQuery: null, options: {} };
  }

  /**
   * Removes all table data stored in local storage
   *
   * @param {string} resource which data should be removed
   */
  static resetTableState(resource) {
    if (!resource) {
      return;
    }

    const key = TableStateManager.createKey(resource);
    window.localStorage.removeItem(key);
  }

  /**
   * Removes all table data stored in local storage
   */
  static resetAllTableStates() {
    TableStateManager.resources.forEach(resource => {
      TableStateManager.resetTableState(resource);
    });
  }
}

export default TableStateManager;
